import { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Template from './Template';
import TemplateDropdown from './TemplateDropdown';
import TextEditor from './TextEditor';
import Icons from './Icons';

const useStyles = makeStyles(
  () => ({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    dropdown: {
      flex: '0 0 auto',
    },
  }),
  {
    name: 'TextTemplate',
  },
);

function TextTemplate({
  template,
  onChange,
  onChangeType,
  onDelete,
  platformType,
  onUp,
  onDown,
  messageLength,
  isError,
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  const [localTemplate, setLocalTemplate] = useState({
    contentType: 'text/plain',
    data: {
      content: '',
    },
    index: 0,
  });

  const handleChange = value => {
    if (localTemplate.data.content !== value) {
      const data = {
        contentType: 'text/plain',
        data: {
          content: value,
        },
      };

      setLocalTemplate(data);
      onChange(data);
    }
  };

  return (
    <Template>
      <div className={classes.root}>
        <TemplateDropdown
          className={classes.dropdown}
          platformType={platformType}
          messageTemplatetype={template.contentType}
          onChange={onChangeType}
        />
        <Icons
          index={template.index}
          onUp={onUp}
          onDown={onDown}
          onDelete={onDelete}
          messageLength={messageLength}
        />
      </div>
      <TextEditor
        style={{ marginTop: 12 }}
        onChange={handleChange}
        origriData={template.data.content}
        placeholder={t('templates.placeholder')}
        addTooltip={t('originNameTooltip')}
        isError={isError}
      />
    </Template>
  );
}

TextTemplate.defaultProps = {
  onChange: () => {},
  onChangeType: () => {},
  onDelete: () => {},
  onUp: () => {},
  onDown: () => {},
  messageLength: 0,
};

TextTemplate.propTypes = {
  template: PropTypes.shape({
    contentType: PropTypes.oneOf(['text/plain']),
    data: PropTypes.shape({
      content: PropTypes.string,
    }),
  }).isRequired,
  onChange: PropTypes.func,
  onChangeType: PropTypes.func,
  onDelete: PropTypes.func,
  onUp: PropTypes.func,
  onDown: PropTypes.func,
  messageLength: PropTypes.number,
};

export default TextTemplate;
